var _g, _animate, _animate2, _animate3, _animate4, _g2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCloudBodyEvokio(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 200,
    viewBox: "0 0 200 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Body/Default"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1243_33244",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 15,
    y: 35,
    width: 171,
    height: 124
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "cloud"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: 7,
    cx: 98.5,
    cy: 90.5,
    rx: 55.5,
    ry: 55.5,
    fill: "#D9D9D9"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "cx",
    values: "98.5;100.5;102.5;100.5;98.5;100.5;102.5;100.5;98.5;100.5;102.5;100.5;98.5;98.5;98.5",
    begin: "0s",
    dur: "15s",
    repeatCount: "indefinite",
    fill: "freeze",
    calcMode: "linear",
    keyTimes: "0;0.071;0.143;0.214;0.286;0.357;0.429;0.5;0.571;0.643;0.714;0.786;0.857;0.929;1"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "cy",
    values: "90.5;93.5;96.5;93.5;90.5;93.5;96.5;93.5;90.5;93.5;96.5;93.5;90.5;93.5;90.5",
    begin: "0s",
    dur: "15s",
    repeatCount: "indefinite",
    fill: "freeze",
    calcMode: "linear",
    keyTimes: "0;0.071;0.143;0.214;0.286;0.357;0.429;0.5;0.571;0.643;0.714;0.786;0.857;0.929;1"
  })), /*#__PURE__*/React.createElement("ellipse", {
    id: 6,
    cx: 107.5,
    cy: 91.5,
    rx: 40.5,
    ry: 40.5,
    fill: "#D9D9D9"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "cy",
    values: "91.5;94.5;97.5;100.258;111.5;119.5;122.5;124.602;121.602;124.602;136.859;123.445;100.445;103.445;91.5",
    begin: "0s",
    dur: "15s",
    repeatCount: "indefinite",
    fill: "freeze",
    calcMode: "linear",
    keyTimes: "0;0.071;0.143;0.214;0.286;0.357;0.429;0.5;0.571;0.643;0.714;0.786;0.857;0.929;1"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "cx",
    values: "107.5;107.5;127.5;143.5;145.5;145.5;135.5;125.5;105.5;85.5;66;53;63;73;107.5",
    begin: "0s",
    dur: "15s",
    repeatCount: "indefinite",
    fill: "freeze",
    calcMode: "linear",
    keyTimes: "0;0.071;0.143;0.214;0.286;0.357;0.429;0.5;0.571;0.643;0.714;0.786;0.857;0.929;1"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "rx",
    values: "40.5;40.5;40.5;34.5;40.5;40.5;40.5;40.5;40.5;40.5;47;36;36;36;40.5",
    begin: "0s",
    dur: "15s",
    repeatCount: "indefinite",
    fill: "freeze",
    calcMode: "linear",
    keyTimes: "0;0.071;0.143;0.214;0.286;0.357;0.429;0.5;0.571;0.643;0.714;0.786;0.857;0.929;1"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "ry",
    values: "40.5;40.5;40.5;34.5;40.5;40.5;40.5;35.5;35.5;35.5;26;26;26;26;40.5",
    begin: "0s",
    dur: "15s",
    repeatCount: "indefinite",
    fill: "freeze",
    calcMode: "linear",
    keyTimes: "0;0.071;0.143;0.214;0.286;0.357;0.429;0.5;0.571;0.643;0.714;0.786;0.857;0.929;1"
  })), /*#__PURE__*/React.createElement("ellipse", {
    id: 5,
    cx: 43.8631,
    cy: 116.965,
    rx: 28.8631,
    ry: 28.8631,
    fill: "#D9D9D9"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "cy",
    values: "116.965;109.965;112.965;109.965;96.9649;99.9649;102.965;109.602;116.602;129.602;132.602;129.945;126.945;129.945;116.965",
    begin: "0s",
    dur: "15s",
    repeatCount: "indefinite",
    fill: "freeze",
    calcMode: "linear",
    keyTimes: "0;0.071;0.143;0.214;0.286;0.357;0.429;0.5;0.571;0.643;0.714;0.786;0.857;0.929;1"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "cx",
    values: "43.8631;43.8631;53.8631;73.8631;83.8631;103.863;123.863;146.5;152.5;142.5;122.5;88;68;58;43.8631",
    begin: "0s",
    dur: "15s",
    repeatCount: "indefinite",
    fill: "freeze",
    calcMode: "linear",
    keyTimes: "0;0.071;0.143;0.214;0.286;0.357;0.429;0.5;0.571;0.643;0.714;0.786;0.857;0.929;1"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "rx",
    values: "28.8631;28.8631;28.8631;28.8631;28.8631;28.8631;28.8631;31.5;31.5;31.5;31.5;41;41;41;28.8631",
    begin: "0s",
    dur: "15s",
    repeatCount: "indefinite",
    fill: "freeze",
    calcMode: "linear",
    keyTimes: "0;0.071;0.143;0.214;0.286;0.357;0.429;0.5;0.571;0.643;0.714;0.786;0.857;0.929;1"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "ry",
    values: "28.8631;28.8631;28.8631;28.8631;28.8631;28.8631;28.8631;28.5;28.5;28.5;28.5;28.5;28.5;28.5;28.8631",
    begin: "0s",
    dur: "15s",
    repeatCount: "indefinite",
    fill: "freeze",
    calcMode: "linear",
    keyTimes: "0;0.071;0.143;0.214;0.286;0.357;0.429;0.5;0.571;0.643;0.714;0.786;0.857;0.929;1"
  })), /*#__PURE__*/React.createElement("ellipse", {
    id: 4,
    cx: 68.8631,
    cy: 127.277,
    rx: 28.8631,
    ry: 28.8631,
    fill: "#D9D9D9"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "cx",
    values: "68.8631;58.8631;43.8631;43.8631;53.8631;63.8631;83.8631;103.863;133;143;148;148;118;108;68.8631",
    begin: "0s",
    dur: "15s",
    repeatCount: "indefinite",
    fill: "freeze",
    calcMode: "linear",
    keyTimes: "0;0.071;0.143;0.214;0.286;0.357;0.429;0.5;0.571;0.643;0.714;0.786;0.857;0.929;1"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "cy",
    values: "127.277;130.277;133.277;120.277;107.277;100.277;103.277;100.277;94.6875;107.688;120.859;127.859;124.859;127.859;127.277",
    begin: "0s",
    dur: "15s",
    repeatCount: "indefinite",
    fill: "freeze",
    calcMode: "linear",
    keyTimes: "0;0.071;0.143;0.214;0.286;0.357;0.429;0.5;0.571;0.643;0.714;0.786;0.857;0.929;1"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "rx",
    values: "28.8631;28.8631;28.8631;28.8631;28.8631;28.8631;28.8631;28.8631;38;38;38;38;38;38;28.8631",
    begin: "0s",
    dur: "15s",
    repeatCount: "indefinite",
    fill: "freeze",
    calcMode: "linear",
    keyTimes: "0;0.071;0.143;0.214;0.286;0.357;0.429;0.5;0.571;0.643;0.714;0.786;0.857;0.929;1"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "ry",
    values: "28.8631;28.8631;28.8631;28.8631;28.8631;28.8631;28.8631;28.8631;31;31;31;31;31;31;28.8631",
    begin: "0s",
    dur: "15s",
    repeatCount: "indefinite",
    fill: "freeze",
    calcMode: "linear",
    keyTimes: "0;0.071;0.143;0.214;0.286;0.357;0.429;0.5;0.571;0.643;0.714;0.786;0.857;0.929;1"
  })), /*#__PURE__*/React.createElement("ellipse", {
    id: 3,
    cx: 115,
    cy: 129.414,
    rx: 39,
    ry: 29,
    fill: "#D9D9D9"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "cx",
    values: "115;105;95;85;65;55;60;60.5;80.5;100.5;132.5;152.5;152.5;142.5;115",
    begin: "0s",
    dur: "15s",
    repeatCount: "indefinite",
    fill: "freeze",
    calcMode: "linear",
    keyTimes: "0;0.071;0.143;0.214;0.286;0.357;0.429;0.5;0.571;0.643;0.714;0.786;0.857;0.929;1"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "cy",
    values: "129.414;132.414;135.414;132.414;129.414;128.414;121.414;108.102;105.102;108.102;112.445;109.445;126.445;129.445;129.414",
    begin: "0s",
    dur: "15s",
    repeatCount: "indefinite",
    fill: "freeze",
    calcMode: "linear",
    keyTimes: "0;0.071;0.143;0.214;0.286;0.357;0.429;0.5;0.571;0.643;0.714;0.786;0.857;0.929;1"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "rx",
    values: "39;39;39;39;39;39;39;29.5;29.5;29.5;29.5;29.5;29.5;29.5;39",
    begin: "0s",
    dur: "15s",
    repeatCount: "indefinite",
    fill: "freeze",
    calcMode: "linear",
    keyTimes: "0;0.071;0.143;0.214;0.286;0.357;0.429;0.5;0.571;0.643;0.714;0.786;0.857;0.929;1"
  })), /*#__PURE__*/React.createElement("ellipse", {
    id: 2,
    cx: 162.583,
    cy: 122.411,
    rx: 23.4172,
    ry: 23.4172,
    fill: "#D9D9D9"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "cx",
    values: "162.583;152.583;142.583;132.583;109.583;89.5827;65;45;45;65;97;117;137;157;162.583",
    begin: "0s",
    dur: "15s",
    repeatCount: "indefinite",
    fill: "freeze",
    calcMode: "linear",
    keyTimes: "0;0.071;0.143;0.214;0.286;0.357;0.429;0.5;0.571;0.643;0.714;0.786;0.857;0.929;1"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "cy",
    values: "122.411;135.411;138.411;137.411;134.411;137.411;136.016;123.016;110.016;103.016;107.359;104.359;101.359;114.359;122.411",
    begin: "0s",
    dur: "15s",
    repeatCount: "indefinite",
    fill: "freeze",
    calcMode: "linear",
    keyTimes: "0;0.071;0.143;0.214;0.286;0.357;0.429;0.5;0.571;0.643;0.714;0.786;0.857;0.929;1"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "rx",
    values: "23.4172;23.4172;23.4172;23.4172;23.4172;23.4172;28;28;28;28;28;28;28;28;23.4172",
    begin: "0s",
    dur: "15s",
    repeatCount: "indefinite",
    fill: "freeze",
    calcMode: "linear",
    keyTimes: "0;0.071;0.143;0.214;0.286;0.357;0.429;0.5;0.571;0.643;0.714;0.786;0.857;0.929;1"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "ry",
    values: "23.4172;23.4172;23.4172;23.4172;23.4172;23.4172;27.5;27.5;27.5;27.5;27.5;27.5;27.5;27.5;23.4172",
    begin: "0s",
    dur: "15s",
    repeatCount: "indefinite",
    fill: "freeze",
    calcMode: "linear",
    keyTimes: "0;0.071;0.143;0.214;0.286;0.357;0.429;0.5;0.571;0.643;0.714;0.786;0.857;0.929;1"
  })), /*#__PURE__*/React.createElement("ellipse", {
    id: 1,
    cx: 144.067,
    cy: 87.5574,
    rx: 24.5064,
    ry: 24.5064,
    fill: "#D9D9D9"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "cx",
    values: "144.067;154.067;161.067;161.067;143.067;120.5;98;75.5;65.5;47.5;57;77;97;134;144.067",
    begin: "0s",
    dur: "15s",
    repeatCount: "indefinite",
    fill: "freeze",
    calcMode: "linear",
    keyTimes: "0;0.071;0.143;0.214;0.286;0.357;0.429;0.5;0.571;0.643;0.714;0.786;0.857;0.929;1"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "cy",
    values: "87.5574;100.557;113.557;130.557;132.557;135.43;139.016;137.602;129.602;125.773;111.359;108.359;105.359;96.1172;87.5572",
    begin: "0s",
    dur: "15s",
    repeatCount: "indefinite",
    fill: "freeze",
    calcMode: "linear",
    keyTimes: "0;0.071;0.143;0.214;0.286;0.357;0.429;0.5;0.571;0.643;0.714;0.786;0.857;0.929;1"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "rx",
    values: "24.5064;24.5064;24.5064;24.5064;24.5064;27.5;30;32.5;32.5;32.5;30;30;30;30;24.5064",
    begin: "0s",
    dur: "15s",
    repeatCount: "indefinite",
    fill: "freeze",
    calcMode: "linear",
    keyTimes: "0;0.071;0.143;0.214;0.286;0.357;0.429;0.5;0.571;0.643;0.714;0.786;0.857;0.929;1"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "ry",
    values: "24.5064;24.5064;24.5064;24.5064;24.5064;24.5;24.5;22.5;22.5;24.5;25.5;25.5;25.5;25.5;24.5064",
    begin: "0s",
    dur: "15s",
    repeatCount: "indefinite",
    fill: "freeze",
    calcMode: "linear",
    keyTimes: "0;0.071;0.143;0.214;0.286;0.357;0.429;0.5;0.571;0.643;0.714;0.786;0.857;0.929;1"
  })))), _animate || (_animate = /*#__PURE__*/React.createElement("animate", {
    attributeName: "y",
    values: "35;38;41;38;35;38;41;38;35;38;41;38;35;38;35",
    begin: "0s",
    dur: "15s",
    repeatCount: "indefinite",
    fill: "freeze",
    calcMode: "linear",
    keyTimes: "0;0.071;0.143;0.214;0.286;0.357;0.429;0.5;0.571;0.643;0.714;0.786;0.857;0.929;1"
  })), _animate2 || (_animate2 = /*#__PURE__*/React.createElement("animate", {
    attributeName: "width",
    values: "171;164;171;171;161;170;155;161;167;166;167;169;155;168;171",
    begin: "0s",
    dur: "15s",
    repeatCount: "indefinite",
    fill: "freeze",
    calcMode: "linear",
    keyTimes: "0;0.071;0.143;0.214;0.286;0.357;0.429;0.5;0.571;0.643;0.714;0.786;0.857;0.929;1"
  })), _animate3 || (_animate3 = /*#__PURE__*/React.createElement("animate", {
    attributeName: "x",
    values: "15;15;15;15;25;16;21;17;17;15;19;17;27;17;15",
    begin: "0s",
    dur: "15s",
    repeatCount: "indefinite",
    fill: "freeze",
    calcMode: "linear",
    keyTimes: "0;0.071;0.143;0.214;0.286;0.357;0.429;0.5;0.571;0.643;0.714;0.786;0.857;0.929;1"
  })), _animate4 || (_animate4 = /*#__PURE__*/React.createElement("animate", {
    attributeName: "height",
    values: "124;124;124;124;124;123;123;123;123;123;122;121;121;121;124",
    begin: "0s",
    dur: "15s",
    repeatCount: "indefinite",
    fill: "freeze",
    calcMode: "linear",
    keyTimes: "0;0.071;0.143;0.214;0.286;0.357;0.429;0.5;0.571;0.643;0.714;0.786;0.857;0.929;1"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1243_33244)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "color",
    x: 7,
    y: 35,
    width: 188,
    height: 131,
    fill: "url(#cloud-body-color)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "cloud-body-color",
    x1: 101,
    y1: 35,
    x2: 101,
    y2: 166,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "var(--gradient-start-color)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "var(--gradient-end-color)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloudBodyEvokio);
export default __webpack_public_path__ + "static/media/cloud-body-evokio.00ef916f320fec02fc5729fb642bef0d.svg";
export { ForwardRef as ReactComponent };